import { api } from '../core';
import { MEDICAL_RECORDS_FILTERS_TAG } from '../constants';
import { setMedicalRecordsFilters } from '@/store';

export interface MedicalRecordsFiltersCaseStatus {
  raw: string;
  rendered: string;
}

export interface MedicalRecordsFiltersDocumentStatus {
  raw: string;
  rendered: string;
}

export interface MedicalRecordsFiltersProviderType {
  raw: string;
  rendered: string;
}

export interface MedicalRecordsFiltersProviders {
  providerId: string;
  providerName: string;
  providerType: string;
}

export interface MedicalRecordsFiltersCheckedBy {
  userId: string;
  userName: string;
}

export interface MedicalRecordsFiltersUploadedBy {
  userId: string;
  userName: string;
}

export interface MedicalRecordsFiltersResponse {
  caseStatus: MedicalRecordsFiltersCaseStatus[];
  checkedBy: MedicalRecordsFiltersCheckedBy[];
  documentStatus: MedicalRecordsFiltersDocumentStatus[];
  providerTypes: MedicalRecordsFiltersProviderType[];
  providers: (MedicalRecordsFiltersProviders | null)[];
  uploadedBy: MedicalRecordsFiltersUploadedBy[];
}

type MedicalRecordsFiltersProps = object;

const medicalRecordsFiltersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMedicalRecordsFilters: builder.query<MedicalRecordsFiltersResponse, MedicalRecordsFiltersProps>({
      query: () => {
        return {
          url: `medical-records/filters`,
          method: 'GET',
        };
      },
      providesTags: () => [{ type: MEDICAL_RECORDS_FILTERS_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setMedicalRecordsFilters(data));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getMedicalRecordsFilters in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetMedicalRecordsFiltersQuery } = medicalRecordsFiltersApi;
